<yat-billing-address-selection-common id="0c8d2460-020d-4b56-b82e-4752c61a6d6a"
  [billingAddresses$]="billingAddresses$"
  [selectedBillingAddress$]="selectedBillingAddress$"
  (saveSelection)="saveSelectedBillingAddress($event)"
  (deleteAddress)="deleteBillingAddress($event)">
</yat-billing-address-selection-common>
